import React from "react";
import Container from "react-bootstrap/Container";
import Footer from "../components/Footer";


const Privacy = () => {
    return (
            <main className="my-5 mx-0">
                <Container className="container-fluid full-height-container">
                    <div className="p-4 p-md-5 mb-4 rounded text-body-emphasis">
                        <h1>Privacy</h1>
                        <h6>Effective Date: 2025</h6>
                        <br/>
                        <br/>
                        <section>
                            <h5>1. Preamble</h5>
                            <p>
                                Welcome to our website! We place great importance upon the protection of your data and
                                the protection of your privacy.
                                Following, we want to describe which data we process when, for what purpose, and on
                                which legal basis.
                                With this, we want to explain to you how our services work and how the protection of
                                your personal data is guaranteed.
                            </p>
                            This privacy policy can be retrieved, saved and printed at any time at <a
                            href="https://mogockene.com/privacy">https://www.mogockene.com/privacy</a>
                        </section>

                        <br/>

                        <section>
                            <p>
                                At <b>Rushta</b> your privacy is important to us.
                                This Privacy Policy explains how we collect, use, disclose, and safeguard your
                                information when you use our <b>WhatsApp integration software</b> and related services.
                            </p>
                            <p>By using our Services, you agree to the terms of this Privacy Policy. If you do not
                                agree, please do not use our Services.</p>
                        </section>

                        <br/>

                        <section>
                            <h6>1. Information We Collect</h6>

                            <b>a. Information You Provide</b>
                            <ul>
                                <li>Business Information: Name, email, phone number, company name, industry, etc.</li>
                                <li>Account Credentials: Login information when creating an account on our platform.
                                </li>
                                <li>Customer Data: Any data you import or transmit through our WhatsApp integration
                                    software (e.g., contacts, messages, customer identifiers).
                                </li>
                            </ul>

                            <strong>b. Automatically Collected Information</strong>
                            <ul>
                                <li>Usage data (e.g., pages visited, features used, response times).</li>
                                <li>Log data (e.g., IP address, browser type, access times).</li>
                                <li>Device information (e.g., operating system, device identifiers).</li>
                            </ul>
                        </section>

                        <br/>

                        <section>
                            <h6>2. Use of Information</h6>
                            <p>We use the information collected to:</p>
                            <ul>
                                <li>Provide and maintain the Services.</li>
                                <li>Enable integration with WhatsApp Business API.</li>
                                <li>Manage customer support and respond to inquiries.</li>
                                <li>Improve and optimize our Services.</li>
                                <li>Ensure compliance with WhatsApp's and Meta’s policies.</li>
                                <li>Detect, prevent, and address technical issues or fraudulent activity.</li>
                                <li>Send you updates, marketing communications, or service notices (where permitted by
                                    law).
                                </li>
                            </ul>
                        </section>

                        <br/>

                        <section>
                            <h6>3. Customer Data and WhatsApp Messages</h6>
                            <ul>
                                <li>We act as a data processor for any customer data you provide.</li>
                                <li>You, as the business user, are the data controller for messages, contacts,
                                    and other customer information transmitted via WhatsApp through our Services.
                                </li>
                                <li>We do not read or store the content of WhatsApp messages beyond what is necessary
                                    to deliver the service.
                                </li>
                                <li>We do not use or sell customer message data for advertising purposes.</li>
                            </ul>
                        </section>

                        <br/>

                        <section>
                            <h6>4. Data Sharing and Disclosure</h6>
                            <p>We may share information:</p>
                            <ul>
                                <li>With third-party service providers that help operate our Services (e.g., cloud
                                    hosting, analytics).
                                </li>
                                <li>With WhatsApp and Meta, as required to provide the integration.</li>
                                <li>To comply with legal obligations or respond to lawful requests by public
                                    authorities.
                                </li>
                                <li>In connection with a merger, sale, or acquisition.</li>
                            </ul>
                            <p>We <b>do not sell or rent</b> your personal data or customer data to third parties.</p>
                        </section>

                        <br/>

                        <section>
                            <h6>5. Data Security</h6>
                            <p>We implement technical and organizational measures to protect your data, including:</p>
                            <ul>
                                <li>Encryption in transit and at rest.</li>
                                <li>Access controls and authentication.</li>
                                <li>Monitoring and auditing system.</li>
                            </ul>
                            <p>However, no method of transmission over the Internet is 100% secure.</p>
                        </section>

                        <br/>

                        <section>
                            <h6>6. Data Retention</h6>
                            <p>We retain your data only for as long as necessary to provide the Services,
                                comply with legal obligations, and resolve disputes.
                                Customer data can be deleted upon request or termination of the service.</p>
                        </section>

                        <br/>

                        <section>
                            <h6>7. Your Rights</h6>
                            <p>Depending on your location, you may have the right to:</p>
                            <ul>
                                <li>Access, correct, or delete your personal data.</li>
                                <li>Object to or restrict processing of your data.</li>
                                <li>Withdraw consent where we rely on consent.</li>
                                <li>Export your data in a structured format.</li>
                            </ul>

                            <p>Please contact us at <a href="mailto: mogock@gmail.com">mogock@gmail.com</a> to exercise
                                your rights.</p>
                        </section>

                        <br/>

                        <section>
                            <h6>8. International Data Transfers</h6>
                            <p>Your data may be transferred and processed in countries outside your own,
                                including countries that may not offer the same level of data protection.
                                We ensure appropriate safeguards are in place, such as standard contractual clauses.</p>
                        </section>

                        <br/>

                        <section>
                            <h6>9. Third-Party Services</h6>
                            <p>Our Services may contain links to or interact with third-party platforms,
                                including WhatsApp. We are not responsible for the privacy practices of
                                these third parties. Please review WhatsApp's Privacy Policy
                                for more information.</p>
                        </section>

                        <br/>

                        <section>
                            <h6>10. Children’s Privacy</h6>
                            <p>Our Services are intended for use by businesses and are not directed
                                at individuals under 16. We do not knowingly collect personal data from children.</p>
                        </section>

                        <br/>

                        <section>
                            <h6>11. Changes to This Policy</h6>
                            <p>We may update this Privacy Policy from time to time. We will notify you of any
                                material changes and update the "Effective Date" at the top of the policy.</p>
                        </section>

                        <br/>

                        <section>
                            <h6>Contact Us</h6>
                            <p>If you have any questions or concerns about this Privacy Policy, contact us at:</p>
                            <b>Rushta</b> <br/>
                            <b>Email:</b> mogock@gmail.com<br/>
                            <b>Phone:</b> 1-829-935-4441
                        </section>

                    </div>
                </Container>
                <Footer/>
            </main>
    );
}

export default Privacy;